var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mr-1",attrs:{"size":"sm","variant":"info"},on:{"click":function($event){$event.stopPropagation();return _vm.copyEntity(_vm.id)}}},[_c('feather-icon',{attrs:{"icon":"CopyIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }